// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchButton_container__L8Bia","searchButton":"SearchButton_searchButton__zB0aB","spinner":"SearchButton_spinner___hzDs"};